<template lang="pug">
.section-wrapper
  modal-insurers(:newRecord='formInsurer', :is-add='isModalAdd')
  .section-wrapper__container
    transition(name="fade")
      vm-row.heading-preloader(vm-w="12" v-if="isLoadingPreloader")
        vm-col.preloader(vw=12)
          Preloader
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.'+ newRecord.name) }}
      vm-col(vm-type="flex" vm-align="center" vm-w=12)
        vm-row.heading(vm-w="12")
          vm-col.mb-3(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            div
              h2 {{ $t('strings.insurers') }}:
              span {{ $t('strings.description', {attribute: $t('strings.insurers')}) }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              vm-button(icon="plus" @click="addInsurer") {{ $t('strings.add') }}
          vm-row(vm-w="12")
            vm-col.card(vm-sm=12)
              vm-table(v-model="selected"  max-height="350px" :data="insurers" )
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsInsurer") {{ $t('insurers.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsInsurer")
                      .user(v-if="column == 'thumbnail'")
                        .col1
                          vm-avatar(:text="data[indextr]['name']" color="primary" :src="data[indextr]['thumbnail']")
                      slot(v-if="column == 'name'")  {{data[indextr][column]}}
                    vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                          vm-icon(icon="edit-2-outline")
                          slot &nbsp;{{ $t('strings.edit') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="deleteInsurerConfirm(data[indextr], tr)")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
                        //- More actions
              vm-pagination(:total="paginationInsurer.totalPages" v-model="currentPage" goto)
              transition(name="enter")
                .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import Preloader from '@/components/aditionals/Preloader'
import { createNamespacedHelpers } from 'vuex'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('PageSinisterDetails')
const ModalInsurers = () => import('@/components/modals/ModalInsurers.vue')

export default {
  name: 'PageSinisterDetails',
  components: {
    ModalInsurers,
    Preloader
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    isModalAdd: true,
    requiredTab: true,
    currentPage: 1,
    columnsInsurer: ['thumbnail', 'name'],
    columns: ['title', 'type', 'updated_at'],
    columnsOrderBy: ['title', 'type'],
    attributeModal: 'name',
    formInsurer: {
      name: '',
      thumbnail: '',
      phone1: '',
      phone2: ''
    },
    newRecord: {
      id: '',
      name: '',
      seo_title: '',
      meta_description: '',
      data: ''
    },
    states: [
      {
        id: 1,
        name: 'live'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        name: '',
        email: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  validations: {
    newRecord: {
      name: {
        required
      },
      seo_title: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(50)
      },
      meta_description: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(400)
      }
    }
  },
  computed: {
    ...mapGetters(['page', 'insurers', 'paginationInsurer', 'isLoading', 'isLoadingPreloader'])
  },
  watch: {
    currentPage (currentPage) {
      this.loadInsurers({ page: currentPage, page_id: this.$route.params.id })
    }
  },
  async created () {
    this.setLoadingPreloader(true)
    if (this.$route.params.id) {
      await this.loadPage({ id: this.$route.params.id })
      this.newRecord = { ...this.page.data }
      await this.applyFiltersInsurers({
        where: {
          page_id: this.$route.params.id,
          param: ''
        },
        whereIn: {},
        whereBetween: {},
        betweenDates: {
          created_at: []
        },
        orderBy: ''
      })
      this.loadInsurers({ page: this.currentPage, page_id: this.$route.params.id })
    }
    this.setLoadingPreloader(false)
  },
  methods: {
    ...mapActions([
      'loadPage',
      'updatePage',
      'loadInsurers',
      'setModalInsurerVisible',
      'deleteInsurer',
      'setLoadingPreloader',
      'applyFiltersInsurers'
    ]),
    async updateRecord () {
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      try {
        await this.updatePage({ id: this.$route.params.id, data: this.newRecord })
      } catch (error) {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' })
      }
      this.$vm.loading.close('#saveRecord > .con-vm-loading')
    },
    addInsurer () {
      this.isModalAdd = true
      this.setModalInsurerVisible(true)
    },
    editRecord (data) {
      this.formInsurer = data
      this.isModalAdd = false
      this.setModalInsurerVisible(true)
    },
    deleteInsurerConfirm (insurer) {
      let t = this
      this.auxDeleteInsurer = () => {
        t.deleteInsurer(insurer).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.insurer'), attribute: this.$t(insurer.id) }),
        accept: this.auxDeleteInsurer
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
